<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="white" stroke="#FF8C4B" stroke-width="4" />
  </svg>
</template>
<script lang="ts" setup>


</script>
